import React from "react";

function StockReview() {
  return <div>Stock Review</div>;
}

export default StockReview;
